const NUMERIC_SORT_RE = /\b(tinyint|smallint|mediumint|int|integer|bigint|decimal|numeric|real|double|float|money|smallmoney|number)\b/i;
const TEXT_SORT_RE = /(char|text|clob|uuid)/i;

export function isNumericDataType(dataType: string | undefined): boolean {
  if (!dataType) return false;
  return NUMERIC_SORT_RE.test(dataType) && !TEXT_SORT_RE.test(dataType);
}

/**
 * Compare two cell values for sorting. Matches TempSqlite sort semantics:
 * - Nulls last
 * - Numeric columns: signed numeric comparison via CAST(col AS REAL), raw string tiebreaker
 * - Text columns: raw codepoint comparison (matches SQLite BINARY collation)
 */
export function compareValues(
  valueA: unknown,
  valueB: unknown,
  numericColumn: boolean,
): number {
  const aNull = valueA === null || valueA === undefined;
  const bNull = valueB === null || valueB === undefined;
  if (aNull && bNull) return 0;
  if (aNull) return 1;
  if (bNull) return -1;

  if (typeof valueA === 'number' && typeof valueB === 'number') {
    return valueA - valueB;
  }
  if (typeof valueA === 'boolean' && typeof valueB === 'boolean') {
    return Number(valueA) - Number(valueB);
  }
  if (valueA instanceof Date && valueB instanceof Date) {
    return valueA.getTime() - valueB.getTime();
  }

  const aStr = typeof valueA === 'string' ? valueA
    : typeof valueA === 'object' ? JSON.stringify(valueA)
    : String(valueA);
  const bStr = typeof valueB === 'string' ? valueB
    : typeof valueB === 'object' ? JSON.stringify(valueB)
    : String(valueB);

  if (numericColumn) {
    const numA = Number(aStr);
    const numB = Number(bStr);
    const safeA = isNaN(numA) ? 0 : numA;
    const safeB = isNaN(numB) ? 0 : numB;
    if (safeA !== safeB) return safeA - safeB;
  }

  if (aStr < bStr) return -1;
  if (aStr > bStr) return 1;
  return 0;
}
